export enum CustomerOutput {
  RESULT = "RESULT",
  THREEDREDIRECT = "THREEDREDIRECT",
  TRYAGAIN = "TRYAGAIN",
}
